import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Button } from 'src/shared/components/button';
export const Footer = ({ isLoading, isUpdate, isSubmitDisabled }) => {
    const { t } = useTranslation();
    return (_jsx(Button, { type: "submit", loading: isLoading, formId: "mentorship-form", className: "w-full sm:w-auto", disabled: isSubmitDisabled, children: t(isUpdate ? 'general.save' : 'mentorship.create_mentorship') }));
};
